/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptsListResponse } from '../../models/prompts-list-response';
import { PromptType } from '../../models/prompt-type';
import { Site } from '../../models/site';

export interface PromptsGet$Params {
  page: number;
  pageSize?: number;
  promptType?: Array<PromptType>;
  query?: string;
  unorganizedOnly?: boolean;
  'x-app'?: Site;
}

export function promptsGet(
  http: HttpClient,
  rootUrl: string,
  params: PromptsGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromptsListResponse>> {
  const rb = new RequestBuilder(rootUrl, promptsGet.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('promptType', params.promptType, {});
    rb.query('query', params.query, {});
    rb.query('unorganizedOnly', params.unorganizedOnly, {});
    rb.header('x-app', params['x-app'], {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromptsListResponse>;
      }),
    );
}

promptsGet.PATH = '/prompts';
